import Vue from "vue";

export default {
    namespaced: true,
    state: {
        permissions: [],
        sites: [],
        accountId: null,
        userInfo: null,
        isExtrusionFlowEnabled: false,
        reportResources: [],
        reportUserGuid: null
    },
    getters: {
        getPermissions: (state) => state.permissions,
        getSites: (state) => state.sites,
        getAccountId: (state) => state.accountId,
        getUserInfo: (state) => state.userInfo,
        isExtrusionFlowEnabled: (state) => state.isExtrusionFlowEnabled,
        hasPermission: (state) => (name) => {
            return state.permissions.some((p) => p.name === name);
        }
    },
    mutations: {
        SET_REPORT_RESOURCES(state, { resources, userGuid }) {
            state.reportResources = resources;
            state.reportUserGuid = userGuid;
        },
        SET_PERMISSIONS(state, payload) {
            state.permissions = payload;
        },
        SET_SITES(state, payload) {
            state.sites = payload;
        },
        SET_ACCOUNT_ID(state, payload) {
            state.accountId = payload;
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload;
        },
        SET_EXTRUSION_FLOW_ENABLED(state, payload) {
            state.isExtrusionFlowEnabled = !!payload;
        }
    },
    actions: {
        async fetchReportResources({ commit, state }) {
            const userInfo = Vue.$cookies.get('userInfo');
            const userGuid = userInfo?.userData?.guid;
            if (userGuid && state.reportUserGuid === userGuid) return;
            commit('SET_REPORT_RESOURCES', { resources: [] });
            const { data } = await Vue.prototype.$http2.get('/api/v1/extrusion-furnace/reports/options');
            commit('SET_REPORT_RESOURCES', { resources: data.data, userGuid });
        },
        async fetchPermissions({ commit, state, dispatch }) {
            if (state.permissions.length > 0 && state.accountId !== null) {
                return {
                    permissions: state.permissions,
                    sites: state.sites,
                    accountId: state.accountId,
                    isExtrusionFlowEnabled: state.isExtrusionFlowEnabled
                };
            }

            try {
                const response = await Vue.prototype.$http2.get("/api/user/permissions");

                const { permissions, sites, accountId, isExtrusionFlowEnabled } = response.data.data;

                commit("SET_PERMISSIONS", permissions);
                commit("SET_SITES", sites);
                commit("SET_ACCOUNT_ID", accountId);
                commit("SET_EXTRUSION_FLOW_ENABLED", isExtrusionFlowEnabled);

                dispatch("syncUserInfoFromCookie");

                return { permissions, sites, accountId, isExtrusionFlowEnabled };
            } catch (error) {
                console.error("Erro ao buscar permissões no Vuex:", error);
                throw error;
            }
        },

        syncUserInfoFromCookie({ commit }) {
            const userInfo = Vue.$cookies.get("userInfo");
            if (userInfo) {
                commit("SET_USER_INFO", userInfo);
            }
        },

        updateUserInfoCookie({ state }, { ability, currentSite }) {
            const userInfo = state.userInfo || Vue.$cookies.get("userInfo");
            if (!userInfo) return;

            const updatedUserInfo = {
                ...userInfo,
                userData: {
                    ...userInfo.userData,
                    ability: ability || userInfo.userData.ability,
                    sites: state.sites.length > 0 ? state.sites : userInfo.userData.sites
                },
                currentSite: currentSite || userInfo.currentSite
            };

            const domain = window.location.href.includes("indsiders.com");
            Vue.$cookies.set(
                "userInfo",
                updatedUserInfo,
                null,
                null,
                domain ? "indsiders.com" : null
            );

            state.userInfo = updatedUserInfo;
        }
    }
};
